(() => {
  window.GrovaSections.register('grova-native-reviews-page', '.gnr, [data-grova-review-carousel]', (section, scope) => {
    const groups = [...section.querySelectorAll('[data-gnr-panel]')].filter(group => group.children.length);
    const tabs = [...section.querySelectorAll('[data-gnr-tab]')].filter(tab => {
      tab.hidden = !groups.some(group => group.dataset.gnrPanel === tab.dataset.gnrTab);
      return !tab.hidden;
    });
    const track = section.querySelector('[data-gnr-track]');
    const cards = groups.flatMap(group => [...group.children]);
    const controls = section.querySelector('[data-gnr-controls]');
    const previous = section.querySelector('[data-gnr-previous]');
    const next = section.querySelector('[data-gnr-next]');
    const status = section.querySelector('[data-gnr-status]');
    if (!track || !cards.length || !controls || !previous || !next) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let timer;
    let frame;
    let width = track.clientWidth;
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const offset = index => cards[index].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    const nearest = () => {
      let index = 0;
      cards.forEach((card, i) => {
        if (Math.abs(offset(i) - track.scrollLeft) < Math.abs(offset(index) - track.scrollLeft)) index = i;
      });
      return index;
    };
    function sync(announce = false) {
      const index = nearest();
      const category = cards[index].parentElement.dataset.gnrPanel;
      tabs.forEach(tab => {
        const active = tab.dataset.gnrTab === category;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', String(active));
      });
      previous.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= maxScroll() - 1;
      if (announce && status) {
        const tab = tabs.find(item => item.dataset.gnrTab === category);
        status.textContent = tab ? `${tab.textContent.trim()} reviews` : `Review ${index + 1} of ${cards.length}`;
      }
    }
    function show(index, behavior = motion.matches ? 'instant' : 'smooth') {
      current = Math.max(0, Math.min(index, cards.length - 1));
      track.scrollTo({ left: Math.min(offset(current), maxScroll()), behavior });
    }
    function settle() {
      clearTimeout(timer);
      current = nearest();
      sync(true);
    }
    scope.on(track, 'scroll', () => {
      if (!frame) frame = requestAnimationFrame(() => { frame = null; sync(); });
      clearTimeout(timer);
      timer = setTimeout(settle, 160);
    }, { passive: true });
    scope.on(track, 'scrollend', settle);
    scope.on(previous, 'click', () => show(current - 1));
    scope.on(next, 'click', () => show(current + 1));
    scope.on(track, 'keydown', event => {
      if (event.target !== track) return;
      const index = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: cards.length - 1 }[event.key];
      if (index === undefined) return;
      event.preventDefault();
      show(index);
    });
    tabs.forEach((tab, index) => {
      const jump = target => show(cards.indexOf(groups.find(group => group.dataset.gnrPanel === target.dataset.gnrTab).firstElementChild));
      scope.on(tab, 'click', () => jump(tab));
      scope.on(tab, 'keydown', event => {
        const target = { ArrowLeft: (index + tabs.length - 1) % tabs.length, ArrowRight: (index + 1) % tabs.length, Home: 0, End: tabs.length - 1 }[event.key];
        if (target === undefined) return;
        event.preventDefault();
        jump(tabs[target]);
        tabs[target].focus();
      });
    });
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
      if (!track.clientWidth || track.clientWidth === width) return;
      width = track.clientWidth;
      show(current, 'instant');
      current = nearest();
      sync();
    }) : null;
    observer?.observe(track);
    scope.on(motion, 'change', () => { if (motion.matches) show(current, 'instant'); });
    controls.hidden = false;
    current = nearest();
    sync();
    scope.cleanup(() => {
      clearTimeout(timer);
      cancelAnimationFrame(frame);
      observer?.disconnect();
      controls.hidden = true;
    });
  });
})();
